
export default {
    name: 'SvgVerifiedBadge',
    props: {
        color: {
            type: String,
            default: '#709B34',
        },
    },
};
